module.exports = __webpack_public_path__ + "img/MOBILE.2d6fdcce.svg";